import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { Router } from '@angular/router';
import { Subscription } from "rxjs";

import { BreakpointObserver, BreakpointState } from "@angular/cdk/layout";
import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";

import { ApiAuthService } from "@services/api-auth.service";
import { SharedService } from "@services/shared.service";

import { environment } from '@environments/environment';
import { CustomerModel } from "@models/CustomerModel";
import { CustomerType } from "@models/Enums";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
    templateUrl: "./full.component.html",
    styleUrls: ["./full.component.scss"],
})
export class FullComponent implements OnInit, OnDestroy {

    color = "red";
    showDarktheme = false;
    @ViewChild('updateAvailable', { static: true }) updateAvailableModal: any;

    config: PerfectScrollbarConfigInterface = {};

    isDesktop = true;
    isApp = true;
    showLandingPage = false;

    sessionTimerId = null;

    user: CustomerModel = new CustomerModel();

    homeIcon = false;
    isMarket = false;
    showOnlyScan = false;

    private darkThemeSubscription: Subscription = null;

    constructor(
        public breakpointObserver: BreakpointObserver,
        public sharedService: SharedService,
        private router: Router,
        private apiAuthService: ApiAuthService,
        private cdr: ChangeDetectorRef,
        private modalService: NgbModal
    ) {

        this.showDarktheme = this.sharedService.isDarkTheme();

        // valida si es tablet
        this.breakpointObserver
            .observe(["(max-width: 1024px)"])
            .subscribe((state: BreakpointState) => {
                if (state.matches) {
                    this.isDesktop = false;
                } else {
                    this.isDesktop = true;
                }
            });
    }

    ngOnInit() {

        this.sharedService.setPageTitle(null);
        this.sharedService.setPageBack(false);
        this.sharedService.setMainPageBack(false);
        this.sharedService.setHideLoginBtn(false);

        this.sharedService.showPreLogin = false;

        this.sharedService.showHeaderNav.subscribe((showHeader) => {

            this.cdr.detectChanges();
        });

        this.isApp = navigator.userAgent?.toLowerCase().indexOf("canvas") > -1;

        if (environment.production) {
            // Acceso dentro del app Mobiloud
            if (this.isApp) {

                this.modalService.open(this.updateAvailableModal, {
                    backdrop: 'static', keyboard: false,
                    size: 'md', centered: true, windowClass: 'modal-full'
                });

                // Se oculta el landing page
                this.showLandingPage = false;
            }
            // Acceso desde web en giviapp.com o holagivi.com
            else {

                // Se muestra el landing page
                this.showLandingPage = true;
                return;
            }
        } else {

            // Se oculta el landing page
            this.showLandingPage = false;
        }

        const session = this.apiAuthService.getSession();
        if (!session || !session.user) {
            this.router.navigate(["login"]);
            return;
        }

        this.user = session.user;

        this.showOnlyScan = this.user.type == CustomerType.GiviScan;
        if (this.showOnlyScan) {
            this.router.navigate(["gsa"]);
        }

        // Chequea si tiene session
        this.sessionTimerId = setInterval(() => {
            if (this.sessionTimerId) {
                if (!session) {
                    this.router.navigate(["login"]);
                }
            }
        }, 5000);

        this.darkThemeSubscription = this.sharedService.darkThemeSubject.subscribe(show => this.showDarktheme = show);
    }

    ngOnDestroy(): void {
        if (this.sessionTimerId) {
            clearInterval(this.sessionTimerId);
        }
        if (this.darkThemeSubscription) {
            this.darkThemeSubscription.unsubscribe();
            this.darkThemeSubscription = null;
        }
    }

    onUpdate() {
        
        const userAgent = navigator.userAgent || navigator.vendor;

        let os: string | null = null;

        // Valida con regex si el usuario está en un dispositivo Android o iOS
        if (/android/i.test(userAgent)) {
            os = 'Android';
        } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
            os = 'iOS';
        }

        if (os === 'Android') {
            window.open('https://play.google.com/store/apps/details?id=com.Givi.android');
        } else if (os === 'iOS') {
            window.open('https://apps.apple.com/us/app/givi-regalos-por-un-mensaje/id6443953772');
        }
    }

    onToggleTheme() {
        
        this.sharedService.setDarkTheme(!this.sharedService.isDarkTheme());
    }
}
